import React, { useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth, signOut } from "firebase/auth";

export default function MakeMeAdmin() {
  const [status, setStatus] = useState("");

  const handleMakeAdmin = async () => {
    try {
      // ✅ Use your actual region
      const functions = getFunctions(undefined, "europe-west2");
      const makeMeAdmin = httpsCallable(functions, "makeMeAdmin");

      const result = await makeMeAdmin();
      const message = result?.data?.message || "✅ You are now admin.";

      // ✅ Force logout to refresh token with new custom claims
      const auth = getAuth();
      await signOut(auth);

      setStatus(`${message} Please sign back in to refresh your token.`);
    } catch (err) {
      console.error(err);
      setStatus(`❌ Error: ${err.message || "Something went wrong."}`);
    }
  };

  return (
    <div
      style={{
        padding: "2rem",
        fontFamily: "system-ui, sans-serif",
        maxWidth: 400,
        margin: "2rem auto",
        textAlign: "center",
        border: "1px solid #ccc",
        borderRadius: 8,
      }}
    >
      <h2 style={{ marginBottom: "1rem" }}>Grant Admin Access</h2>

      <button
        onClick={handleMakeAdmin}
        style={{
          padding: "10px 20px",
          background: "#5a67d8",
          color: "white",
          fontWeight: "bold",
          border: "none",
          borderRadius: 6,
          cursor: "pointer",
        }}
      >
        Make Me Admin
      </button>

      {status && (
        <p style={{ marginTop: "1rem", fontSize: "0.95rem" }}>{status}</p>
      )}
    </div>
  );
}
